module.exports = __webpack_public_path__ + "static/img/2.5.514b458.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/hk/upload/picture/2.5.jpg
// module id = YcAD
// module chunks = 7